"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ComposerSettings = _interopRequireDefault(require("composer-lib/data/model/ComposerSettings"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _constants = require("composer-lib/lib/constants");

var _Revisions500Error = _interopRequireDefault(require("./Revisions500Error"));

var _RevisionPreview = _interopRequireDefault(require("./RevisionPreview"));

var _RevisionsList = _interopRequireDefault(require("./RevisionsList"));

var _Revisions = _interopRequireDefault(require("composer-lib/data/model/Revisions"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UISettings = _interopRequireDefault(require("composer-lib/data/model/UISettings"));

var _UIScrollingColumns = _interopRequireDefault(require("UIComponents/layout/UIScrollingColumns"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var langKey = function langKey(key) {
  return "composer-lib.revisionsModal." + key;
};

var _default = (0, _createReactClass.default)({
  displayName: "RevisionsModal",
  propTypes: {
    composerSettings: _propTypes.default.instanceOf(_ComposerSettings.default),
    fetchNextRevisions: _propTypes.default.func.isRequired,
    getEditorProps: _propTypes.default.func.isRequired,
    hideRevisions: _propTypes.default.func.isRequired,
    onRevertClick: _propTypes.default.func.isRequired,
    revisions: _propTypes.default.instanceOf(_Revisions.default).isRequired,
    selectedRevision: _propTypes.default.number,
    selectRevision: _propTypes.default.func.isRequired,
    selectedRevisionObject: _propTypes.default.object,
    uiSettings: _propTypes.default.instanceOf(_UISettings.default).isRequired
  },
  refreshPage: function refreshPage() {
    window.location.reload();
  },
  contactSupport: function contactSupport() {
    window.location.href = 'https://help.hubspot.com';
  },
  handleScroll: function handleScroll(evt) {
    var _this$props = this.props,
        fetchNextRevisions = _this$props.fetchNextRevisions,
        revisions = _this$props.revisions;
    var target = evt.target;

    if (revisions.fetchStatus === _constants.RequestStatus.PENDING) {
      // scroll events fire OFTEN; avoid duplicate fetches
      return;
    }

    if (!target.querySelector("." + _constants.REVISIONS_LIST_CLASSNAME)) {
      // scrolling other column
      return;
    }

    var clientHeight = target.clientHeight,
        scrollHeight = target.scrollHeight,
        scrollTop = target.scrollTop;
    var LIST_ITEM_HEIGHT = 64; // start fetching before we actually hit the bottom

    if (scrollTop + clientHeight >= scrollHeight - LIST_ITEM_HEIGHT) {
      fetchNextRevisions();
    }
  },
  renderButtons: function renderButtons() {
    var _this$props2 = this.props,
        hideRevisions = _this$props2.hideRevisions,
        onRevertClick = _this$props2.onRevertClick,
        selectedRevision = _this$props2.selectedRevision;
    return _react.default.createElement("div", {
      className: "revisions-button-container"
    }, _react.default.createElement(_UIButton.default, {
      "data-test": "confirm-revert-revision",
      disabled: !selectedRevision,
      onClick: onRevertClick,
      use: "primary"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: langKey('confirmButton')
    })), _react.default.createElement(_UIButton.default, {
      onClick: hideRevisions,
      use: "secondary"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: langKey('cancelButton')
    })));
  },
  renderBody: function renderBody() {
    var _this$props3 = this.props,
        composerSettings = _this$props3.composerSettings,
        getEditorProps = _this$props3.getEditorProps,
        revisions = _this$props3.revisions,
        selectedRevision = _this$props3.selectedRevision,
        selectedRevisionObject = _this$props3.selectedRevisionObject,
        selectRevision = _this$props3.selectRevision,
        uiSettings = _this$props3.uiSettings;

    if (uiSettings.showFetchRevisionsFailedError) {
      return _react.default.createElement(_Revisions500Error.default, {
        className: "revisions-fetch-failed-error",
        introKey: "loadIntro"
      });
    }

    if (revisions.size === 0 && revisions.fetchStatus !== _constants.RequestStatus.SUCCEEDED || !selectedRevision) {
      return _react.default.createElement(_UILoadingSpinner.default, {
        "data-test-id": "content-loading",
        grow: true,
        minHeight: 700
      });
    }

    var rightContent = _react.default.createElement(_RevisionPreview.default, {
      composerSettings: composerSettings,
      getEditorProps: getEditorProps,
      revision: selectedRevisionObject
    });

    var leftContent = _react.default.createElement(_RevisionsList.default, {
      revisions: revisions,
      selectedRevision: selectedRevision,
      selectRevision: selectRevision
    });

    return _react.default.createElement(_UIScrollingColumns.default, {
      className: "revisions-modal-body display-flex",
      leftColumnContent: leftContent,
      leftColumnFooter: this.renderButtons(),
      leftColumnMinWidth: '25%',
      maxHeight: 800,
      rightColumnContent: rightContent,
      rightColumnWidth: '75%',
      onScroll: this.handleScroll
    });
  },
  render: function render() {
    var _this$props4 = this.props,
        hideRevisions = _this$props4.hideRevisions,
        uiSettings = _this$props4.uiSettings;

    if (!uiSettings.showRevisions) {
      return null;
    }

    return _react.default.createElement(_UIModal.default, {
      className: "revisions-modal",
      width: 1100
    }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
      onClick: hideRevisions
    }), _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: langKey('header')
    }))), _react.default.createElement(_UIDialogBody.default, {
      className: "p-all-0"
    }, this.renderBody()));
  }
});

exports.default = _default;
module.exports = exports.default;